import { captureMessage } from "@sentry/vue";

import type { ApiError } from "@/Services/Api/Models";
import type { PatientPool } from "@/Modules/Models/Domain/PatientsPool";
import { ApiErrorCodes } from "@/Modules/App/Models/Api/ApiErrorCodes";
import { NotificationType } from "@/Modules/App/Models/Domain/NotificationType";

import PatientPoolTransformer from "@/Modules/Transformers/PatientPool";

import { postAssigmentPatient } from "@/Services/TherapyApi/PatientsPool";

import useAppStore from "@/Modules/App/Store";
import usePatientPoolStore from "@/Modules/PatientsPool/Store";
import useUserStore from "@/Modules/User/Store";

const patientPoolTransformer = PatientPoolTransformer;

async function assigmentPatientAH(customerUuid: string): Promise<PatientPool | undefined> {
  const appStore = useAppStore();
  const patientsPoolStore = usePatientPoolStore();
  const userStore = useUserStore();

  patientsPoolStore.isLoading = true;

  try {
    const patientPoolApi = await postAssigmentPatient(customerUuid);
    const patientPool = patientPoolTransformer.toDomain(patientPoolApi);

    patientsPoolStore.getPatientsPoolList(userStore.user!.id);

    appStore.showSnackbar({
      type: NotificationType.INFO,
      message: "chat.assignment.confirmation_assignment_msg",
    });

    return patientPool;
  } catch (e: unknown) {
    const error = e as ApiError;

    captureMessage(`Assigment error: ${error.error_code}`);

    if (
      [ApiErrorCodes.CUSTOMER_HAS_THERAPIST, ApiErrorCodes.CUSTOMER_IS_NOW_IN_ASSIGMENT].includes(
        error.error_code as ApiErrorCodes
      )
    ) {
      appStore.showSnackbar({
        type: NotificationType.ERROR,
        message: "chat.assignment.error_assignment_msg",
      });
    } else {
      appStore.showSnackbar({
        type: NotificationType.ERROR,
        message: "there_was_an_error_connecting_to_the_server_please_try_again_later",
      });
    }

    return undefined;
  } finally {
    patientsPoolStore.isLoading = false;
  }
}

export default assigmentPatientAH;
